export enum CurrencyType {
  USD = "USD",
  UZS = "UZS",
}
